import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { Box, Typography } from '@mui/material'
import { isDailyRecurrence, isWeeklyRecurrence, isYearlyRecurrence as isYearlyRecurrenceUtil } from 'utils/service'
import T from 'T'
import EditServiceRecurrenceFrequencySelector from './EditServiceRecurrenceFrequencySelector'
import EditServiceRecurrenceDaysOfWeekSelector from './EditServiceRecurrenceDaysOfWeekSelector'
import EditServiceRecurrenceNonWeeklySelector from './EditServiceRecurrenceNonWeeklySelector'
import { getUniqueRecurrenceOptions, findRecurrenceOptionByKey } from '../utils/recurrenceOptionsHelper'

const EditServiceRecurrenceForm = ({ metaFiltersData = {}, showYearly = false, isCompact = false }) => {
  const { watch } = useFormContext()

  const watchedServiceIntervalKey = watch('serviceInterval')

  const recurrenceOptions = useMemo(() => getUniqueRecurrenceOptions(metaFiltersData), [metaFiltersData])

  const watchedServiceInterval = useMemo(() => {
    return findRecurrenceOptionByKey(recurrenceOptions, watchedServiceIntervalKey)
  }, [recurrenceOptions, watchedServiceIntervalKey])

  // Check if the selected interval is daily
  const isDailyInterval = useMemo(() => {
    if (!watchedServiceIntervalKey) return false

    const uniqueRecurrenceOptions = getUniqueRecurrenceOptions(metaFiltersData)
    const selectedServiceInterval = findRecurrenceOptionByKey(uniqueRecurrenceOptions, watchedServiceIntervalKey)

    return selectedServiceInterval && isDailyRecurrence(selectedServiceInterval.recurrenceInterval)
  }, [watchedServiceIntervalKey, metaFiltersData])

  const isWeeklyRecurrenceType = useMemo(() => {
    if (!watchedServiceInterval) return true // Default to weekly behavior
    return isWeeklyRecurrence(watchedServiceInterval.recurrenceInterval)
  }, [watchedServiceInterval])

  const isYearlyRecurrence = useMemo(() => {
    return isYearlyRecurrenceUtil(watchedServiceInterval?.recurrenceInterval)
  }, [watchedServiceInterval])

  return (
    <Box>
      <Typography variant="h6" mb={2}>
        {T.RECURRENCE}
      </Typography>

      <EditServiceRecurrenceFrequencySelector metaFiltersData={metaFiltersData} showYearly={showYearly} />

      {isWeeklyRecurrenceType && <EditServiceRecurrenceDaysOfWeekSelector isCompact={isCompact} />}
      {!isWeeklyRecurrenceType && !isDailyInterval && !isYearlyRecurrence && <EditServiceRecurrenceNonWeeklySelector />}
    </Box>
  )
}

EditServiceRecurrenceForm.propTypes = {
  metaFiltersData: PropTypes.object,
  showYearly: PropTypes.bool,
  isCompact: PropTypes.bool,
}

export default EditServiceRecurrenceForm
